export default "__VITE_ASSET__CaNtfick__"